<form [formGroup]="currencyForm">
  <ng-container *ngIf="field">
    <mat-form-field class="d-block ab-select" [floatLabel]="'never'" hideRequiredMarker>
      <mat-select formControlName="currencyCode" (openedChange)="touch()">
        <mat-option
          *ngFor="let value of field.values"
          [value]="value.fields.Value.value"
        >
          {{ value.fields.Label.value }}</mat-option
        >
      </mat-select>
    </mat-form-field>
  </ng-container>
  <ng-container *ngIf="currencyInput">
    <div class="currency-prefix">
      <div>{{ currencyCode.value }}</div>
    </div>
  </ng-container>
  <div class="w-100">
    <input
      abAmountFormatter
      pipeFormat="1.2-2"
      formControlName="amount"
      type="text"
      class="form-control"
      (blur)="touch()"
      [maxlength]="maxlength"
      [placeholder]="placeholder"
    />
  </div>
</form>
